import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`
